var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.245 357.658C139.415 357.658 91.7461 309.823 91.7461 250.811V206.295C91.7461 117.763 163.271 46 251.495 46C339.726 46 411.251 117.763 411.251 206.295V250.811C411.251 309.823 363.56 357.658 304.744 357.658H198.245Z",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.12 170.663L162.752 277.517C211.763 326.684 291.24 326.698 340.251 277.517L366.861 170.663C295.599 141.036 213.034 138.685 136.12 170.663Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.743 357.657H198.243C183.767 357.657 169.964 354.737 157.397 349.494L165.804 394.814C190.583 410.671 219.941 419.982 251.5 419.982C283.066 419.982 312.418 410.664 337.189 394.814L345.61 349.494C333.014 354.737 319.219 357.657 304.743 357.657Z",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.986 473.416H322.486C342.117 473.416 357.993 489.344 357.993 509.034V615.888H286.986V473.416Z",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.989 473.416H180.49C160.873 473.416 144.99 489.344 144.99 509.034V615.888H286.989V473.416Z",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1945 438.703L53.5347 441.488C35.4938 448.989 18.9722 471.037 16.8351 490.52L2.99023 580.291C2.99023 580.291 22.0181 580.291 40.4637 580.291C58.9023 580.291 81.9913 588.306 91.7466 598.1C101.509 607.874 109.496 615.888 109.496 615.888H144.996V523.78L60.1945 438.703Z",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.788 438.703L449.44 441.488C467.481 448.989 484.003 471.037 486.161 490.52L499.999 580.291C499.999 580.291 480.964 580.291 462.54 580.291C444.094 580.291 421.005 588.306 411.236 598.1C401.48 607.874 393.493 615.888 393.493 615.888H357.993V523.766L442.788 438.703Z",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.185 473.416H180.488C160.871 473.416 144.988 489.344 144.988 509.034V523.78L60.1934 438.702L131.2 409.204L195.185 473.416Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.993 523.765V509.034C357.993 489.344 342.118 473.416 322.486 473.416H307.775L371.781 409.204L442.795 438.702L357.993 523.765Z",
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.184 473.415H307.767L371.78 409.203L337.197 394.813C312.404 410.663 283.06 419.967 251.5 419.967C219.941 419.967 190.597 410.642 165.804 394.813L131.206 409.203L195.184 473.415Z",
    stroke: "#303030",
    strokeWidth: 15,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 485,
    height: 485,
    rx: 42.5,
    stroke: "#303030",
    strokeWidth: 15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personal_icon.2cbbd8a97b3968f1dd1545627e453be3.svg";
export { ForwardRef as ReactComponent };